<template>
    <v-layout class="login-wrapper" align-center justify-space-between column fill-height grid-list-md fluid>
        <login-server-error v-if="showServerError"></login-server-error>
        <v-form >
                <v-layout wrap>
                    <v-flex>
                        <v-text-field
                                id='email'
                                type="email"
                                @keyup.enter.prevent="inputLogin"
                                v-model="email"
                                tabindex="1"
                                :label="$t('common.login.email')"
                                required></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex>
                        <v-text-field @keyup.enter.prevent="inputLogin"
                                      data-qa="password"
                                      type="password"
                                      v-model="password"
                                      tabindex="2"
                                      :error-messages="passwordError"
                                      :label="$t('common.login.password')"
                                      required
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <div class="forgot-password-wrapper">
                    <span v-if="!isMobileApp" @click="forgotPassword" class="forgot-password">{{$t('common.login.forgot_password_short')}}</span>
                </div>
                <vue-recaptcha
                  v-if="showRecaptcha"
                  ref="recaptcha"
                  :sitekey="recaptchaSiteKey"
                  @verify="onVerify">
                  <v-btn
                      depressed
                      text
                      data-qa="login-button"
                      :loading="inProgress"
                      :style="{ backgroundColor: branding.secondary_color, color: branding.text_color}">
                      {{$t('common.login.login')}}
                  </v-btn>
                </vue-recaptcha>
                <v-btn
                  v-else
                  depressed
                  text
                  data-qa="login-button"
                  :loading="inProgress"
                  :style="{ backgroundColor: branding.secondary_color, color: branding.text_color}"
                  @click="loginDirect">
                  {{$t('common.login.login')}}
                </v-btn>
        </v-form>

        <v-layout v-if="showExternalLogin" align-center class="separator">
            <div class="separator-part"></div>
            <div class="separator-text">{{$t('common.login.or')}}</div>
            <div class="separator-part"></div>
        </v-layout>


        <v-layout v-if="showExternalLogin" class="social" column>
            <div @click="externalLogin('facebook_login')" class="login-button facebook-login">
              <span class="socialSpan"><img class="socialLogo" src="@/assets/images/facebook_logo.png"></span>
              {{$t('common.login.login_with_facebook')}}
            </div>
            <div @click="externalLogin('google_login')" class="login-button google-login">
              <span class="socialSpan"><img class="socialLogo" src="@/assets/images/google_logo.png"></span>
              {{$t('common.login.login_with_google')}}
            </div>

        </v-layout>
    </v-layout>
</template>

<script>
    import {authService} from '@/modules/auth/services/authService.js'
    import LoginServerError from "./LoginServerError";
    import { mapActions, mapGetters } from "vuex";
    import {postMessageService} from "@/modules/common/services";
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        name: 'LoginWithPassword',
        components: {LoginServerError, VueRecaptcha},
        data() {
            return {
                email: '',
                password: '',
                passwordError: '',
                inProgress: false,
                showServerError: false,
                recaptchaToken: null,
            }
        },
        computed:{
            ...mapGetters({isMobileApp: 'isMobileApp', branding: "brandModule/branding"}),
            showExternalLogin(){return !this.isMobileApp && !(this.branding && (this.branding.whitelabel || this.branding.co_branded_managed)) },
            showRecaptcha() {
              return window.app_config.env.production
            },
            recaptchaSiteKey() {
              return window.app_config.recaptchaSiteKey
            }
        },
        methods: {

            async loginDirect() {
                this.inProgress = true;
                if (this.$store.getters.vcitaWindowLocation) {
                  this.$track('Login Click', {'Info': 'Popup', 'Page': 'App Login','Platform': this.$store.getters.platform, 'Origin': 'Password Form'})
                }
                let result = await authService.login({recaptchaToken: this.recaptchaToken, email: this.email, username: this.email, password: this.password})
                if(result && result.success === false){
                    if(result.error === 'invalid_credentials'){
                         this.passwordError =  this.$t('common.login.invalid')
                    }else if(result.error === 'server_error'){
                        this.showServerError = true
                    }
                    this.recaptchaToken = null
                    if (this.$refs.recaptcha && this.$refs.recaptcha.reset) this.$refs.recaptcha.reset()
                    this.inProgress = false
                } else this.$track('Login success', {'Info': 'Popup', 'Page': 'App Login','Platform': this.$store.getters.platform, 'Type': 'password', 'Origin': 'Password Form'})
            },
            externalLogin: function(login_type) {
                postMessageService.post(login_type)
            },
            forgotPassword: function() {
              this.$track('Login - forgot my password click', {'Info': 'Popup', 'Page': 'App Login','Platform': this.$store.getters.platform, 'Origin': 'Password Form'})
              this.$router.push({name: "forgotpassword", params: {shouldDisplayLinkInvalidMessage: false}});
            },
            inputLogin: function() {
              if (this.showRecaptcha && this.$refs.recaptcha && this.$refs.recaptcha.execute) this.$refs.recaptcha.execute()
              else this.loginDirect()
            },
            onVerify: function (response) {
              if (response) {
                this.recaptchaToken = response
                this.loginDirect()
              }
            },

        }
    }
</script>


<style scoped lang="scss">
@import "@/assets/scss/abstract/_variables.scss";

    .social{
        width: 100%;
    }

    .socialSpan {
      left: 0;
      margin-left: 15px;
      margin-top: 5px;
      position: absolute;
    }

    .socialLogo {
      height: 20px;
    }

    .separator{
        width: 100%;
        height: 60px;
        min-height: 60px;
        max-height: 60px;

        .separator-part{
            background: rgba(0, 0, 0, 0.08);
            height: 1px;
            width: 42%;
            float:left;
        }

        .separator-text{
            text-align: center;
            width: 16%;
            line-height: 3px;
            color:rgba(51, 51, 51, 0.54);
        }
    }

    .forgot-password-wrapper{
        margin-bottom: 26px;
        height: 18px;
        margin-top: -14px;
    }

    .login-button{
        width: 100%;
        height: 40px;
        cursor: pointer;
        border-radius: 2px;
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.15);
        background-color: #ffffff;
        font-size: 14px;
        line-height: 40px;
        text-align: center;
        font-family: Roboto;
        font-weight: 500;
        letter-spacing: 0.22px;

        &.facebook-login{
            background-color: #2553b4;
            background-size: 33px 42px;
            background-position-x: 17px;
            margin-bottom: 10px;
            color: #ffffff;
            position: relative;
        }

        &.google-login{
            background-color: #ffffff;
            color: rgba(0, 0, 0, 0.54);
            background-size: 33px 42px;
            background-position-x: 17px;
            position: relative;
        }

    }

</style>
